import React from "react";
import { Outlet } from "react-router";
import { Navigate } from "react-router-dom";
import EmployeeWrapper from "../containers/EmployeeWrapper";
import AdminWrapper from "../containers/AdminWrapper";
import { isTokenExpired } from "../utils/isTokenExpired";

//has profiles
//is current or first Profile personal

export default function PrivateRoute({ requiredRole, redirectPath, children }) {
  try {
    let role = localStorage.getItem("role");
    let token = localStorage.getItem("token");

    // Redirect immediately if token is missing or expired
    if (!token || isTokenExpired(token)) {
      localStorage.clear();
      return <Navigate to={redirectPath} replace />;
    }

    if (role !== null) {

      if (requiredRole === role) {
        return children ? children : <Outlet />;
      } else if (role === "EMPLOYEE" && token) {
        return <EmployeeWrapper />
      } else if (role === "ADMIN" && token) {
        return <AdminWrapper />;
      } else {
        return <Navigate to={redirectPath} replace />;
      }
    } else {
      return <Navigate to={redirectPath} replace />;
    }
  } catch (err) {
    return <Navigate to={redirectPath} replace />;
  }
}
